<template>
  <v-container class="max-w-full" fluid v-if="!$apollo.loading">
    <v-row>
      <v-col sm="12" lg="5"
        ><LostPropertiesForm :lost-property="lostProperty"
      /></v-col>
      <v-col sm="12" lg="7"
        ><LostPropertiesEvents :events="lostProperty.events"
      /></v-col>
    </v-row>
    <v-row></v-row>
  </v-container>
</template>

<script>
import GET_LOST_PROPERTY from '@/gql/lostProperties/queries/GetLostProperty.gql'
import LostPropertiesForm from './LostPropertiesForm'
import LostPropertiesEvents from './LostPropertiesEvents'

export default {
  name: 'LostPropertiesDetails',

  components: {
    LostPropertiesEvents,
    LostPropertiesForm,
  },

  apollo: {
    lostProperty: {
      query: GET_LOST_PROPERTY,

      variables() {
        return {
          uuid: this.$route.params.uuid,
        }
      },
    },
  },
}
</script>
